import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelPortuguese_osx_iso: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
    meta: [
      {
        label: 'å',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 5,
    label: 'B',
    meta: [
      {
        label: '∫',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 6,
    label: 'C',
    meta: [
      {
        label: '©',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: '∂',
        modifiers: MOD.ALT,
      },
      {
        label: '∆',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '∆',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: 'Æ',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
    meta: [
      {
        label: 'ƒ',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 10,
    label: 'G',
    meta: [
      {
        label: '˙',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 11,
    label: 'H',
    meta: [
      {
        label: 'ˇ',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 12,
    label: 'I',
    meta: [
      {
        label: 'ı',
        modifiers: MOD.ALT,
      },
      {
        label: '˚',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '˚',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 13,
    label: 'J',
    meta: [
      {
        label: '¯',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 14,
    label: 'K',
    meta: [
      {
        label: '„',
        modifiers: MOD.ALT,
      },
      {
        label: '‚',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '‚',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: '‘',
        modifiers: MOD.ALT,
      },
      {
        label: '’',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '’',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: 'M',
    meta: [
      {
        label: 'µ',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 17,
    label: 'N',
    meta: [
      {
        label: '¬',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 18,
    label: 'O',
    meta: [
      {
        label: 'Ø',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: 'π',
        modifiers: MOD.ALT,
      },
      {
        label: '∏',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '∏',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'Q',
    meta: [
      {
        label: 'Œ',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'R',
    meta: [
      {
        label: '®',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
    meta: [
      {
        label: '™',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 24,
    label: 'U',
    meta: [
      {
        label: '†',
        modifiers: MOD.ALT,
      },
      {
        label: '‡',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '‡',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 25,
    label: 'V',
    meta: [
      {
        label: '√',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 26,
    label: 'W',
    meta: [
      {
        label: '∑',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 27,
    label: 'X',
    meta: [
      {
        label: '«',
        modifiers: MOD.ALT,
      },
      {
        label: '»',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '»',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: 'Y',
    meta: [
      {
        label: '¥',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 29,
    label: 'Z',
    meta: [
      {
        label: 'Ω',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ' (Apple logo)',
        modifiers: MOD.ALT,
      },
      {
        label: '¡',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '¡',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.ALT,
      },
      {
        label: 'ﬁ',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'ﬁ',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '€',
        modifiers: MOD.ALT,
      },
      {
        label: 'ﬂ',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'ﬂ',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '£',
        modifiers: MOD.ALT,
      },
      {
        label: '¢',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '¢',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '‰',
        modifiers: MOD.ALT,
      },
      {
        label: '∞',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '∞',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¶',
        modifiers: MOD.ALT,
      },
      {
        label: '•',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '•',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '/',
        modifiers: MOD.SFT,
      },
      {
        label: '/',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '÷',
        modifiers: MOD.ALT,
      },
      {
        label: '⁄',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '⁄',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '[',
        modifiers: MOD.ALT,
      },
      {
        label: '{',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ']',
        modifiers: MOD.ALT,
      },
      {
        label: '}',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: '=',
        modifiers: MOD.SFT,
      },
      {
        label: '=',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '≠',
        modifiers: MOD.ALT,
      },
      {
        label: '≈',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '≈',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: "'",
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¿',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '¿',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '+',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '◊',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '◊',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'º',
    meta: [
      {
        label: 'ª',
        modifiers: MOD.SFT,
      },
      {
        label: 'ª',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '°',
        modifiers: MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: '´ (dead)',
    meta: [
      {
        label: '` (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '` (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¨ (dead)',
        modifiers: MOD.ALT,
      },
      {
        label: '˝',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '˝',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: '(backslash)',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '‹',
        modifiers: MOD.ALT,
      },
      {
        label: '›',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '›',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'Ç',
    meta: [
      {
        label: '¸',
        modifiers: MOD.ALT,
      },
      {
        label: '˛',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '˛',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: '~ (dead)',
    meta: [
      {
        label: '^ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '^ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˜ (dead)',
        modifiers: MOD.ALT,
      },
      {
        label: 'ˆ (dead)',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: 'ˆ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '§',
    meta: [
      {
        label: '±',
        modifiers: MOD.SFT,
      },
      {
        label: '±',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: ';',
        modifiers: MOD.SFT,
      },
      {
        label: ';',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '“',
        modifiers: MOD.ALT,
      },
      {
        label: '”',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '”',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '…',
        modifiers: MOD.ALT,
      },
      {
        label: '·',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '·',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 56,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '—',
        modifiers: MOD.ALT,
      },
      {
        label: '–',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '–',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 100,
    label: '<',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '≤',
        modifiers: MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.SFT | MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '"',
  },
  {
    code: 544,
    label: '#',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '&',
  },
  {
    code: 548,
    label: '/',
  },
  {
    code: 549,
    label: '(',
  },
  {
    code: 550,
    label: ')',
  },
  {
    code: 551,
    label: '=',
  },
  {
    code: 557,
    label: '?',
  },
  {
    code: 558,
    label: '*',
  },
  {
    code: 559,
    label: 'ª',
  },
  {
    code: 560,
    label: '` (dead)',
  },
  {
    code: 562,
    label: '|',
  },
  {
    code: 564,
    label: '^ (dead)',
  },
  {
    code: 565,
    label: '±',
  },
  {
    code: 566,
    label: ';',
  },
  {
    code: 567,
    label: ':',
  },
  {
    code: 568,
    label: '_',
  },
  {
    code: 612,
    label: '>',
  },
  {
    code: 1028,
    label: 'å',
  },
  {
    code: 1029,
    label: '∫',
  },
  {
    code: 1030,
    label: '©',
  },
  {
    code: 1031,
    label: '∂',
  },
  {
    code: 1032,
    label: 'Æ',
  },
  {
    code: 1033,
    label: 'ƒ',
  },
  {
    code: 1034,
    label: '˙',
  },
  {
    code: 1035,
    label: 'ˇ',
  },
  {
    code: 1036,
    label: 'ı',
  },
  {
    code: 1037,
    label: '¯',
  },
  {
    code: 1038,
    label: '„',
  },
  {
    code: 1039,
    label: '‘',
  },
  {
    code: 1040,
    label: 'µ',
  },
  {
    code: 1041,
    label: '¬',
  },
  {
    code: 1042,
    label: 'Ø',
  },
  {
    code: 1043,
    label: 'π',
  },
  {
    code: 1044,
    label: 'Œ',
  },
  {
    code: 1045,
    label: '®',
  },
  {
    code: 1046,
    label: 'ß',
  },
  {
    code: 1047,
    label: '™',
  },
  {
    code: 1048,
    label: '†',
  },
  {
    code: 1049,
    label: '√',
  },
  {
    code: 1050,
    label: '∑',
  },
  {
    code: 1051,
    label: '«',
  },
  {
    code: 1052,
    label: '¥',
  },
  {
    code: 1053,
    label: 'Ω',
  },
  {
    code: 1054,
    label: ' (Apple logo)',
  },
  {
    code: 1055,
    label: '@',
  },
  {
    code: 1056,
    label: '€',
  },
  {
    code: 1057,
    label: '£',
  },
  {
    code: 1058,
    label: '‰',
  },
  {
    code: 1059,
    label: '¶',
  },
  {
    code: 1060,
    label: '÷',
  },
  {
    code: 1061,
    label: '[',
  },
  {
    code: 1062,
    label: ']',
  },
  {
    code: 1063,
    label: '≠',
  },
  {
    code: 1071,
    label: '°',
  },
  {
    code: 1072,
    label: '¨ (dead)',
  },
  {
    code: 1074,
    label: '‹',
  },
  {
    code: 1075,
    label: '¸',
  },
  {
    code: 1076,
    label: '˜ (dead)',
  },
  {
    code: 1078,
    label: '“',
  },
  {
    code: 1079,
    label: '…',
  },
  {
    code: 1080,
    label: '—',
  },
  {
    code: 1124,
    label: '≤',
  },
  {
    code: 1543,
    label: '∆',
  },
  {
    code: 1548,
    label: '˚',
  },
  {
    code: 1550,
    label: '‚',
  },
  {
    code: 1551,
    label: '’',
  },
  {
    code: 1555,
    label: '∏',
  },
  {
    code: 1560,
    label: '‡',
  },
  {
    code: 1563,
    label: '»',
  },
  {
    code: 1566,
    label: '¡',
  },
  {
    code: 1567,
    label: 'ﬁ',
  },
  {
    code: 1568,
    label: 'ﬂ',
  },
  {
    code: 1569,
    label: '¢',
  },
  {
    code: 1570,
    label: '∞',
  },
  {
    code: 1571,
    label: '•',
  },
  {
    code: 1572,
    label: '⁄',
  },
  {
    code: 1573,
    label: '{',
  },
  {
    code: 1574,
    label: '}',
  },
  {
    code: 1575,
    label: '≈',
  },
  {
    code: 1581,
    label: '¿',
  },
  {
    code: 1582,
    label: '◊',
  },
  {
    code: 1584,
    label: '˝',
  },
  {
    code: 1586,
    label: '›',
  },
  {
    code: 1587,
    label: '˛',
  },
  {
    code: 1588,
    label: 'ˆ (dead)',
  },
  {
    code: 1590,
    label: '”',
  },
  {
    code: 1591,
    label: '·',
  },
  {
    code: 1592,
    label: '–',
  },
  {
    code: 1636,
    label: '≥',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '"',
  },
  {
    code: 4640,
    label: '#',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '&',
  },
  {
    code: 4644,
    label: '/',
  },
  {
    code: 4645,
    label: '(',
  },
  {
    code: 4646,
    label: ')',
  },
  {
    code: 4647,
    label: '=',
  },
  {
    code: 4653,
    label: '?',
  },
  {
    code: 4654,
    label: '*',
  },
  {
    code: 4655,
    label: 'ª',
  },
  {
    code: 4656,
    label: '` (dead)',
  },
  {
    code: 4658,
    label: '|',
  },
  {
    code: 4660,
    label: '^ (dead)',
  },
  {
    code: 4661,
    label: '±',
  },
  {
    code: 4662,
    label: ';',
  },
  {
    code: 4663,
    label: ':',
  },
  {
    code: 4664,
    label: '_',
  },
  {
    code: 4708,
    label: '>',
  },
  {
    code: 5639,
    label: '∆',
  },
  {
    code: 5644,
    label: '˚',
  },
  {
    code: 5646,
    label: '‚',
  },
  {
    code: 5647,
    label: '’',
  },
  {
    code: 5651,
    label: '∏',
  },
  {
    code: 5656,
    label: '‡',
  },
  {
    code: 5659,
    label: '»',
  },
  {
    code: 5662,
    label: '¡',
  },
  {
    code: 5663,
    label: 'ﬁ',
  },
  {
    code: 5664,
    label: 'ﬂ',
  },
  {
    code: 5665,
    label: '¢',
  },
  {
    code: 5666,
    label: '∞',
  },
  {
    code: 5667,
    label: '•',
  },
  {
    code: 5668,
    label: '⁄',
  },
  {
    code: 5669,
    label: '{',
  },
  {
    code: 5670,
    label: '}',
  },
  {
    code: 5671,
    label: '≈',
  },
  {
    code: 5677,
    label: '¿',
  },
  {
    code: 5678,
    label: '◊',
  },
  {
    code: 5680,
    label: '˝',
  },
  {
    code: 5682,
    label: '›',
  },
  {
    code: 5683,
    label: '˛',
  },
  {
    code: 5684,
    label: 'ˆ (dead)',
  },
  {
    code: 5686,
    label: '”',
  },
  {
    code: 5687,
    label: '·',
  },
  {
    code: 5688,
    label: '–',
  },
  {
    code: 5732,
    label: '≥',
  },
];
